import React from 'react';
import { Hero } from './components/Hero';
import { EmotionalStory } from './components/EmotionalStory';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { WhatYouGet } from './components/WhatYouGet';
import { ForYouSection } from './components/ForYouSection';
import { HowItWorks } from './components/HowItWorks';
import { FAQ } from './components/FAQ';
import { PricingCTA } from './components/PricingCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-cream font-sans text-earth-darker selection:bg-accent/20 selection:text-accent" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <EmotionalStory data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <SolutionSection data-id="element-5" />
        <WhatYouGet data-id="element-6" />
        <ForYouSection data-id="element-7" />
        <HowItWorks data-id="element-8" />
        <FAQ data-id="element-9" />
        <PricingCTA data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}